import React, { useState, useEffect } from 'react'
import { useTranslation } from 'i18n'
import { CSSTransition } from 'react-transition-group'
import queryString from 'query-string'
import './StartSlideWrapper.scss'
import { StepSpacingWrapper } from 'components/StepSpacingWrapper/StepSpacingWrapper'
import StepBackground from './StepBackground4'
// handleStartSlideClick allows parent components to prevent this from starting
const StartSlideWrapper = ({
  step,
  children,
  handleStartSlideClick = function () {},
  footer,
  startScreenDisabled,
  isIntersecting,
}) => {
  const { t } = useTranslation('stepShell')
  let showStartScreen = step.hasStartScreen && !startScreenDisabled
  //   console.log(`rendering start slide wrapper ${step.id}`)
  //complete step never has start screen
  if (step.type === 'COMPLETE') {
    showStartScreen = false
  }
  const [startScreenDisabledByQuery, setStartScreenDisabledByQuery] =
    useState(false)
  useEffect(() => {
    checkQuery()
  }, [])
  const checkQuery = () => {
    try {
      if (window !== undefined) {
        let query = queryString.parse(window.location.search)
        if (query) {
          if (query.galleryitem || query.stepId) {
            setStartScreenDisabledByQuery(true)
          }
        }
      }
    } catch (error) {
      console.log(`error`, error)
    }
  }

  const hasStartScreen = showStartScreen === true && !startScreenDisabledByQuery
  const [startSlideActive, setStartSlideActive] = useState(true)

  const startSlideClickHandler = async () => {
    let result = await handleStartSlideClick()

    // non-step3 steps don't return anything
    // step3 returns false if something prevents us from starting
    if (result === undefined || result === true) {
      setStartSlideActive(false)
    }
  }
  const animationDuration = 600

  const StartSlide = ({
    headline,
    para,
    startFooter,
    bgImageExists,
    backgroundImageId,
    backgroundColor,
    mobileBackgroundId,
    backgroundImageAlt,
    mobileBackgroundImageAlt,
    onStartClicked,
    footer,
    isIntersecting,
    buttonCopy,
  }) => {
    // Step-type names are keyed per locale; unknown types fall back to the
    // generic label (previously util/stepTypeStrings, which was English-only).
    const stepName = t(`stepType.${step.type}`, {
      defaultValue: t('stepType.default'),
    })
    return (
      <div
        className={`start-slide ${
          footer ? `has-html-footer` : `no-html-footer`
        }`}
      >
        <StepBackground
          backgroundImageId={backgroundImageId}
          backgroundColor={backgroundColor}
          mobileBackgroundId={mobileBackgroundId || backgroundImageId} // older breaks displayed the desktop image on mobile. we need to account for that untl content has an opportunity to fix.
          backgroundImageAlt={backgroundImageAlt}
          mobileBackgroundImageAlt={mobileBackgroundImageAlt}
        />
        <div className="container start-slide-container">
          <div className={`start-slide-inner-content-wrapper`}>
            <div
              className={`start-slide__content${
                !bgImageExists ? ' no-background' : ''
              }`}
            >
              <h2
                className="start-screen-headline step-content__title"
                dangerouslySetInnerHTML={{ __html: headline }}
              ></h2>
              <p
                className="start-body start-screen-copy"
                dangerouslySetInnerHTML={{ __html: para }}
              ></p>
              {/* added ID is for hacky css overrides in beaker. */}
              <button
                tabIndex={isIntersecting ? 0 : -1}
                role="button"
                id="start-slide-button"
                className="btn start-button"
                onClick={onStartClicked}
              >
                {buttonCopy || t('startCta', { stepName })}
              </button>

              <div
                className="start-footer"
                dangerouslySetInnerHTML={{ __html: startFooter }}
              />
            </div>
          </div>
        </div>
        { footer }
      </div>
    )
  }
  return (
    <>
      {hasStartScreen ? (
        <StepSpacingWrapper noPadding={startSlideActive}>
          <div className="start-wrapper">
            <style
              dangerouslySetInnerHTML={{
                __html: `
            .transition-slide {
              transition: transform ${animationDuration}ms ease-in-out;
            }
        `,
              }}
            />
            <CSSTransition
              className={`transition-slide transition-start-slide ${
                startSlideActive ? 'is--active' : 'is--inactive'
              }`}
              key={`start-slide`}
              in={startSlideActive === true}
              exit={startSlideActive === false}
              timeout={animationDuration}
              unmountOnExit={false}
              /* appear={startSlideActive === true}*/
            >
              <div className="start-wrapper-item start-wrapper-start">
                <StartSlide
                  isIntersecting={isIntersecting}
                  headline={step.startHeader || step.headline}
                  para={step.startBody}
                  startFooter={step.startFooter}
                  footer={footer}
                  backgroundImageId={step.startBackgroundImageId || (step.startBackgroundImage && step.startBackgroundImage.id)}
                  backgroundColor={step.startBackgroundColor}
                  mobileBackgroundId={step.mobileStartBackgroundImageId || (step.mobileStartBackgroundImage && step.mobileStartBackgroundImage.id)}
                  backgroundImageAlt={(step.startBackgroundImage && step.startBackgroundImage.altAttribute) || ''}
                  mobileBackgroundImageAlt={(step.mobileStartBackgroundImage && step.mobileStartBackgroundImage.altAttribute) || ''}
                  onStartClicked={startSlideClickHandler}
                  buttonCopy={step.startButtonCopy}
                />
              </div>
            </CSSTransition>

            <CSSTransition
              className={`transition-slide transition-content-slide ${
                startSlideActive ? 'is--inactive' : 'is--active'
              }`}
              timeout={600}
              in={startSlideActive === false}
              enter={startSlideActive === false}
              key={`content-slide`}
              /* appear={startSlideActive === false} */
            >
              <div className="start-wrapper-item start-wrapper-content">
                {children}
              </div>
            </CSSTransition>
          </div>
        </StepSpacingWrapper>
      ) : (
        <StepSpacingWrapper>{children}</StepSpacingWrapper>
      )}
    </>
  )
}

export default StartSlideWrapper
